var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9603 30.3333H11.9603C4.72029 30.3333 1.62695 27.24 1.62695 20V12C1.62695 4.75999 4.72029 1.66666 11.9603 1.66666H19.9603C27.2003 1.66666 30.2936 4.75999 30.2936 12V20C30.2936 27.24 27.2136 30.3333 19.9603 30.3333ZM11.9603 3.66666C5.81362 3.66666 3.62695 5.85332 3.62695 12V20C3.62695 26.1467 5.81362 28.3333 11.9603 28.3333H19.9603C26.107 28.3333 28.2936 26.1467 28.2936 20V12C28.2936 5.85332 26.107 3.66666 19.9603 3.66666H11.9603Z",
    fill: "#286FB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35995 27.2666C4.10661 27.2666 3.85328 27.1732 3.65328 26.9732C3.26661 26.5866 3.26661 25.9466 3.65328 25.5599L25.5866 3.62658C25.9733 3.23991 26.6133 3.23991 27 3.62658C27.3866 4.01325 27.3866 4.65324 27 5.03991L5.06661 26.9732C4.87995 27.1732 4.62661 27.2666 4.35995 27.2666Z",
    fill: "#286FB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4121 25C20.8654 25 20.4121 24.5466 20.4121 24V17.3333C20.4121 16.7866 20.8654 16.3333 21.4121 16.3333C21.9588 16.3333 22.4121 16.7866 22.4121 17.3333V24C22.4121 24.5466 21.9588 25 21.4121 25Z",
    fill: "#286FB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 21.6667H18C17.4533 21.6667 17 21.2134 17 20.6667C17 20.12 17.4533 19.6667 18 19.6667H24.6667C25.2133 19.6667 25.6667 20.12 25.6667 20.6667C25.6667 21.2134 25.2133 21.6667 24.6667 21.6667Z",
    fill: "#286FB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 11H7.33398C6.78732 11 6.33398 10.5467 6.33398 10C6.33398 9.45333 6.78732 9 7.33398 9H14.0007C14.5473 9 15.0007 9.45333 15.0007 10C15.0007 10.5467 14.5473 11 14.0007 11Z",
    fill: "#286FB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/ResultIcon.f4e9d6c60080f144abaeafc2649e120f.svg";
export { ForwardRef as ReactComponent };